/**
 * @param preFilterConfigs - An ES6 Map of {@link PreFilterConfig} objects which determines how to
 * set up the filter logic
 * @returns an array of {@link URLParamFilterInput} objects
 */
export const mapPreFilterConfigsToParamInputs = (
    preFilterConfigs: Map<string, PreFilterConfig>,
): URLParamFilterInput[] =>
    Array.from(preFilterConfigs.values()).map(
        ({
            id,
            urlParamKey,
            filterValuePath,
            filterValueType,
        }: PreFilterConfig): URLParamFilterInput => ({
            id,
            filterValuePath,
            filterValueType,
            paramKey: urlParamKey,
        }),
    );
